<template>
    <div class="status">
        <p class="status__title">{{ $lang('archive.subtitle') }}</p>
        <ul class="status__list">
            <li class="status__item" v-for="(item, index) in statuses" :key="index">
                <button
                    class="btn btn--middle btn--border-radius--50 status__button"
                    :class="{
                        'btn--main-bg': item.id === historicalStatusId,
                        'btn--border-bg': item.id !== historicalStatusId,
                        'btn--with-icon--left': item.icon,
                    }"
                    @click="onChangeStatus(item)"
                >
                    <component
                        class="status__icon"
                        :class="{'status__icon--active': item.id === historicalStatusId}"
                        v-if="item.icon"
                        :is="item.icon"
                    />
                    <span>{{ $lang(item.name) }}</span>
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import ArchiveStatusIconStar from "./ArchiveStatusIconStar.vue";
import ArchiveStatusIconUser from "./ArchiveStatusIconUser.vue";
import ArchiveStatusIconFeather from "./ArchiveStatusIconFeather.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    name: 'ArchiveStatus',
    components: {
        ArchiveStatusIconUser,
        ArchiveStatusIconFeather,
        ArchiveStatusIconStar,
    },
    data() {
        return {
            statuses: [
                {
                    id: null,
                    name: 'status.all',
                },
                {
                    id: 2,
                    name: 'status.famous',
                    icon: 'ArchiveStatusIconUser',
                },
                {
                    id: 4,
                    name: 'status.interesting',
                    icon: 'ArchiveStatusIconFeather',
                },
                {
                    id: 3,
                    name: 'status.military',
                    icon: 'ArchiveStatusIconStar',
                },
            ],
        };
    },
    computed: {
        ...mapGetters('archive', [
            'historicalStatusId',
        ]),
    },
    methods: {
        ...mapMutations('archive', [
            'setHistoricalStatusId',
        ]),
        ...mapActions('archive', [
            'getPages',
        ]),
        onChangeStatus(item) {
            this.setHistoricalStatusId(item.id);
            this.getPages();
            this.$router.push({ name: 'archive', params: { statusId: item.id }});
        }
    },
}
</script>

<style lang="scss" scoped>
.status__title {
    color: #A9B1C2;
    font-size: 16px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: -0.25px;
}
.status__list {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    margin: -6px;
    margin-top: 1.2rem;
}
.status__item {
    margin: 6px;
}
.status__button {
    padding: 10px 20px;
    &:hover {
        .status__icon {
            color: #fff;
        }
    }
}
.status__icon {
    width: 20px;
    height: 20px;
    color: #00B4FF;
    &--active {
        color: #fff;
    }
}
</style>
